import antdData from 'antd/lib/locale-provider/es_ES'
import localeData from 'react-intl/locale-data/es'

const messages = {
  // general
  copyright: '2020 ForteSitio. Derechos reservados',
  language: 'Idioma',

  // topBar
  'topBar.issuesHistory': 'Experiencia',
  'topBar.projectManagement': 'Proyectos',
  'topBar.typeToSearch': 'Escriba su búsqueda...',
  'topBar.buyNow': 'Información',
  'topBar.bitcoin': 'Actividad',
  'topBar.profileMenu.hello': 'Hola',
  'topBar.profileMenu.billingPlan': 'Suscripción',
  'topBar.profileMenu.company': 'Empresa',
  'topBar.profileMenu.role': 'Rol',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Teléfono',
  'topBar.profileMenu.editProfile': 'Editar Perfil',
  'topBar.profileMenu.logout': 'Salir',

  // login
  'user.login.top.back': 'ATRAS',
  'user.login.top.login': 'INGRESAR',
  'user.login.top.about': 'ACERCA DE',
  'user.login.top.support': 'SOPORTE',

  // Pages.User.Login
  'user.login.title': 'BIENVENIDO A LA PLATAFORMA DIGITAL PARA INDUSTRIA 4.0',
  'user.login.instructions1': 'Connecte sus dispositivos a la nube para distribuir la información',
  'user.login.instructions2':
    'Diseñe la estructura que su compañia necesita para estar justo a tiempo',
  'user.login.instructions3':
    'Reciba alarmas y notificaciones con la app mobil, consulte o monitoree su proceso',
  'user.login.block.title': 'POR FAVOR INGRESE',
  'user.login.block.email': 'Correo electrónico',
  'user.login.block.email.initial.value': 'usuario@dominio.com',
  'user.login.block.email.required.message': 'Ingrese su dirección de correo electrónico',
  'user.login.block.password': 'Contraseña',
  'user.login.block.password.initial.value': 'password',
  'user.login.block.password.required.message': 'Ingrese su contraseña',
  'user.login.block.rememberme': 'Recordarme',
  'user.login.block.forgot.password': '¿ Olvidó su contraseña ?',
  'user.login.block.button.login': 'Ingresar',
  'user.login.block.register': 'Regístrese',
  'user.login.block.register.if': 'si aún no tiene cuenta',
  'user.login.block.another': 'Usar otro servicio para ingresar',

  // pages.user.forgot
  'user.forgot.caption': 'RESTABLECER CONSTRASEÑA',
  'user.forgot.username': 'Nombre de usuario (dirección de correo)',
  'user.forgot.username.message': 'Ingrese su nombre de usuario o dirección de correo',
  'user.forgot.backlogin': 'Volver a login (entrar)',
  'user.forgot.button': 'Restablecer',

  // pages.user.register
  'user.register.title': 'REGISTRO DE NUEVO USUARIO',
  'user.register.instructions1':
    'Por favor ingrese la información solicitada para procesar su registro',
  'user.register.instructions2':
    'Recibirá un mensaje de correo electrónico con instrucciones para completar el proceso',
  'user.register.form.caption': 'Registro',
  'user.register.form.username.message': 'Nombre de usuario o dirección de correo electrónico',
  'user.register.form.username.error.message': 'Ingrese una dirección de correo electrónico',
  'user.register.form.password.message': 'Ingrese su contraseña',
  'user.register.form.password.error.message': 'Ingrese una contraseña',
  'user.register.form.passwordConfirm.message': 'Confirme su contraseña',
  'user.register.form.passwordConfirm.error.message': 'Las contraseñas no coinciden',
  'user.register.form.button': 'Registrarse',
  'user.register.form.invitation.message': 'Código de invitación (opcional)',
  'user.register.form.invitation.error.message':
    'Ingrese un código de invitación en caso de tener uno',
  'user.register.form.suscript': 'Suscribirse al boletín de correo electrónico',
  'user.register.another': 'Usar otro servicio para registrarse',

  // pages footer
  'footer.termsOfUse': 'TERMINOS DE USO',
  'footer.compliance': 'CONFORMIDAD',
  'footer.confidential': 'INFORMACION CONFIDENCIAL',
  'footer.support': 'SOPORTE',
  'footer.contacts': 'CONTACTOS',

  // pages.tags
  'tag.path': 'Ruta del Tag',
  'tag.value': 'Valor del Tag',

  // issuesHistory
  'issuesHistory.currentSearch': 'Búsqueda actual',
  'issuesHistory.searchForIssues': 'Buscar fallas conocidas',
  'issuesHistory.opened': 'Abiertos',
  'issuesHistory.PLAIN4-253': 'PLAIN4-253 Virtual PLC...',
  'issuesHistory.PLAIN4-234': 'PLAIN4-234 Diseño de P...',
  'issuesHistory.PLAIN4-424': 'PLAIN4-424 Permisos de...',
  'issuesHistory.more': 'Mas...',
  'issuesHistory.filters': 'Filtros',
  'issuesHistory.myOpenIssues': 'Mis fallos abiertos',
  'issuesHistory.reportedByMe': 'Reportados por mi',
  'issuesHistory.settings': 'Configuración',

  // project management
  'projects.active': 'Activos',
  'projects.controlMultiloop': 'Multilazo de control',
  'projects.biolerRoom': 'Sala de calderas',
  'projects.mechatronicLab': 'Laboratorio de mecatrónica',
  'projects.inactive': 'Inactivos',
  'projects.plcExamples': 'Prácticas de PLC',
  'projects.settings': 'Configuración',

  // settings
  'settings.theme': 'Configuración de apariencia',
  'settings.menuTop': 'Menú Superior (Horizontal)',
  'settings.collapsed': 'Menú Compacto',
  'settings.shadow': 'Menú Sombreado',
  'settings.light': 'Tema brillante',
  'settings.borderless': 'Tarjetas sin Borde',
  'settings.squared': 'Bordes Cuadrados',
  'settings.fixed': 'Ancho Fijo',

  // dashboard
  'dashboard.monitor': 'Monitorear Tags de proyecto',
  'dashboard.tagsRefreshed': 'Valores actualizados',
  'dashboard.tagsMessage': 'Los valores mostrados aqui se actualizan cada 4 segundos',
  'dashboard.path': 'Ruta',
  'dashboard.value': 'Valor',
  'dashboard.origin': 'Origen',
  'dashboard.dateTime': 'Fecha y Hora',
  'dashboard.products': 'Productos',
  'dashboard.productsHeader': 'Lista de Productos',
  'dashboard.productsInstruction': 'Mostrar o modificar la lista de productos',
  'dashboard.company': 'Empresas',
  'dashboard.companyHeader': 'Empresas',
  'dashboard.companyInstruction': 'Mostrar o modificar la lista de empresas',
  'dashboard.users': 'Usuarios',
  'dashboard.usersInstruction': 'Mostrar o modificar la lista de usuarios',
  'dashboard.usersHeader': 'Usuarios',
  'dashboard.group': 'Grupos',
  'dashboard.groupHeader': 'Grupos y sub-grupos',
  'dashboard.groupInstruction': 'Mostrar o editar grupos o sub-grupos',
  'dashboard.project': 'Proyectos',
  'dashboard.projectInstruction': 'Mostrar o editar los proyectos de trabajo',
  'dashboard.projectHeader': 'Proyectos',
  'dashboard.site': 'Ubicación',
  'dashboard.siteHeader': 'Ubicación',
  'dashboard.siteInstruction': 'Mostrar o editar la lista de ubicaciones',
  'dashboard.device': 'Dispositivos',
  'dashboard.deviceHeader': 'Dispositivos',
  'dashboard.deviceInstruction': 'Mostrar o editar la lista de dispositivos',
  'dashboard.tag': 'Variables',
  'dashboard.tagHeader': 'Variables',
  'dashboard.tagInstruction': 'Mostrar o editar la lista de variables',
  'dashboard.use': 'Uso/Unidades',

  // update Tags
  'updateTags.setTagValue': 'Establecer el valor del Tag',
  'updateTags.tagPath': 'Ruta del Tag',
  'updateTags.tagValue': 'Valor del Tag',
  'updateTags.send': 'Enviar',
  'updateTags.cancel': 'Cancelar',

  // user profile
  'userProfile.title': 'Perfil de Usuario',
  'userProfile.systemInfo': 'Información del Sistema',
  'userProfile.login': 'Nombre de inicio de sesión',
  'userProfile.nickName': 'Nombre corto',
  'userProfile.status': 'Estado',
  'userProfile.firstName': 'Nombre(s)',
  'userProfile.lastName': 'Apellido(s)',
  'userProfile.contactInfo': 'Información de contacto',
  'userProfile.email': 'Correo electrónico',
  'userProfile.mobile': 'Número de celular',
  'userProfile.securityInfo': 'Información de Seguridad',
  'userProfile.password': 'Contraseña',
  'userProfile.confirm': 'Confirmar Contraseña',
  'userProfile.save': 'Grabar',
  'userProfile.cancel': 'Cancelar',
  'userProfile.drag': 'Hacer click o arrastrar un archivo a ésta área para cargar una imágen',
  'userProfile.selectFile': 'Seleccionar archivo',

  // navigation
  'navigation.home': 'Inicio',

  // menu
  'menu.settings.title': 'Configuración',
  'menu.dashboardAlpha.title': 'Tablero',
  'menu.pricingTable.title': 'Actualizar Tags',
  'menu.userProfile.title': 'Perfil de Usuario',
  'menu.company.title': 'Empresa',
  'menu.project.title': 'Proyecto',
  'menu.platform.title': 'Plataforma',
  'menu.analysis.title': 'Análisis',

  // Company Menu
  'menu.companyGroups.title': 'Grupos',
  'menu.companyUsers.title': 'Usuarios',
  'menu.companyGroupsUsers.title': 'Agrupar Usuarios',

  // Platform Menu
  'menu.platformProducts.title': 'Productos',
  'menu.platformCompany.title': 'Empresas',
  'menu.platformUsers.title': 'Usuarios',

  // Project Menu
  'menu.projectProjects.title': 'Proyectos',
  'menu.projectSites.title': 'Ubicaciones',
  'menu.projectDevices.title': 'Dispositivos',
  'menu.projectTags.title': 'Variables',

  // table common
  'table.operation': 'Operación',
  'table.deleteMessage': '¿ Borrar registro ?',

  // action buttons
  'item.add': 'Agregar',
  'item.delete': 'Borrar',
  'item.edit': 'Editar',

  // column names  common
  'data.id': 'id',
  'data.uid': 'uuid',
  'data.sysname': 'Sysname',
  'data.nickname': 'Nombre',
  'data.status': 'Status',
  'data.version': 'Versión',
  'data.datetimedatajson': 'FechaHora JSON',
  'data.sysdatajson': 'Datos del Sistema JSON',
  'data.extradatajson': 'Datos Extras',
  'data.operdatajson': 'Datos de operación',
  'data.details': 'Detalles',

  // status values
  'status.active': 'Activo',
  'status.created': 'Creado',
  'status.stopped': 'Pausado',
  'status.cancelled': 'Cancelado',
  'status.done': 'Terminado',

  // product column names
  'product.sku': 'Código SKU',
  'product.price': 'Precio',
  'product.kind': 'Tipo',
  'product.path': 'Ruta',
  'product.photo': 'Foto',
  'product.details': 'Detalles JSON',

  // product kinds
  'productKind.service': 'Servicio',
  'productKind.storage': 'Almacenamiento',
  'productKind.electronic': 'Electrónica',

  // company column names
  'company.photo': 'Foto',
  'company.details': 'Detalles JSON',

  // group column names
  'company.id': 'EmpresaId',
  'company.uid': 'EmpresaUid',
  'user.id': 'UsuarioId',
  'user.uid': 'UsuarioUid',
  'group.id': 'GrupoId',
  'group.uid': 'GrupoUid',
  'group.master': 'SubGrupo de',
  'group.grouping': 'Usuarios del grupo',

  // project colum names
  'project.masterUser': 'Usuario Administrador',
  'project.users': 'Usuarios del proyecto',
  'project.groups': 'Grupos del proyecto',

  // sites colum names
  'site.masterUser': 'Usuario encargado',
  'site.details': 'Detalles',

  // device column names
  'device.kind': 'Tipo',
  'device.projectMaster': 'Proyecto',
  'device.siteMaster': 'Ubicación',
  'device.details': 'Detalles',
  'device.kindLocal': 'Local',
  'device.kindRemote': 'Remoto',
  'device.kindAuroraHMI': 'Aurora HMI',
  'device.path': 'Ruta',

  // tags column names
  'tag.kind': 'Origen',
  'tag.type': 'Tipo',
  'tag.readonly': 'Solo Lectura',
  'tag.persistent': 'Histórico',
  'tag.deviceMaster': 'Dispositivo',
  'tag.details': 'Detalles',
  'tag.kindCalculated': 'Calculado',
  'tag.kindLocal': 'Local',
  'tag.kindRemote': 'Remoto',
  'tag.typeBoolean': 'Bit',
  'tag.typeInteger': 'Entero',
  'tag.typeFloat': 'Flotante',
  'tag.typeString': 'Alfanumérico',

  // analysis page messages
  'analysis.title': 'Análisis',
  'analysis.dashboard': 'Proyecto: ',
  'analysis.dataRefreshed': 'Gráfico de tendencias',
  'analysis.tagsMessage': 'Datos históricos',
  'analysis.selDevice': 'Dispositivo: ',
  'analysis.selTag': 'Variable: ',
}

export default {
  locale: 'es-ES',
  antdData,
  localeData,
  messages,
}
